var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_332_16223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.83 85.1699C182.83 98.6199 178.84 111.77 171.37 122.95C163.9 134.13 153.28 142.85 140.85 148C128.42 153.15 114.75 154.49 101.56 151.87C88.37 149.25 76.25 142.77 66.74 133.26C57.23 123.75 50.75 111.63 48.13 98.4399C45.51 85.2499 46.85 71.5799 52 59.1499C57.15 46.7199 65.86 36.0999 77.05 28.6299C88.23 21.1599 101.38 17.1699 114.83 17.1699C132.86 17.1799 150.15 24.3499 162.9 37.0999C175.65 49.8499 182.82 67.1399 182.83 85.1699Z",
    fill: "#00C707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.83 85.1699C182.83 98.6199 178.84 111.77 171.37 122.95C163.9 134.13 153.28 142.85 140.85 148C128.42 153.15 114.75 154.49 101.56 151.87C88.37 149.25 76.25 142.77 66.74 133.26C57.23 123.75 50.75 111.63 48.13 98.4399C45.51 85.2499 46.85 71.5799 52 59.1499C57.15 46.7199 65.86 36.0999 77.05 28.6299C88.23 21.1599 101.38 17.1699 114.83 17.1699C132.86 17.1799 150.15 24.3499 162.9 37.0999C175.65 49.8499 182.82 67.1399 182.83 85.1699Z",
    stroke: "#556266",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6756 148.806C52.3084 151.905 52.0102 155.127 50.8174 158.05C49.6246 160.974 47.5882 163.483 44.9627 165.258C42.3444 167.025 39.2534 167.985 36.0897 168C32.9259 168.014 29.8276 167.091 27.1875 165.352C24.5475 163.614 22.4819 161.12 21.2528 158.21C20.0237 155.294 19.6891 152.079 20.2928 148.974C20.8892 145.868 22.4019 143.01 24.6275 140.763C26.853 138.515 29.6967 136.973 32.795 136.341C34.8532 135.904 36.977 135.89 39.0425 136.282C41.108 136.675 43.079 137.475 44.8318 138.639C46.5845 139.795 48.0973 141.294 49.2683 143.039C50.4392 144.785 51.2611 146.741 51.6683 148.806H51.6756Z",
    fill: "#6D45E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.35 41.56C56.91 30.75 71.41 23.61 87.03 21.06C102.64 18.49 118.67 20.62 133.08 27.16C147.49 33.7 159.63 44.37 167.98 57.82C176.33 71.26 180.5 86.88 179.97 102.69C179.44 118.5 174.23 133.8 165 146.66C155.77 159.52 142.94 169.34 128.13 174.9C113.32 180.46 97.19 181.5 81.78 177.9C66.37 174.3 52.38 166.21 41.57 154.65C27.08 139.14 19.35 118.53 20.06 97.32C20.77 76.12 29.87 56.07 45.36 41.57L45.35 41.56Z",
    stroke: "#556266",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.21 20L29.87 23.73",
    stroke: "#556266",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.74 25.9697L34.01 26.6297",
    stroke: "#556266",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.77 34.5003L31.11 30.7803",
    stroke: "#556266",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.24 28.5301L26.97 27.8701",
    stroke: "#556266",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.01 26.6305C33.55 26.7105 33.07 26.7005 32.61 26.6005C32.15 26.5005 31.72 26.3105 31.33 26.0405C30.95 25.7705 30.62 25.4305 30.37 25.0305C30.12 24.6305 29.95 24.1905 29.87 23.7305C29.95 24.1905 29.94 24.6705 29.84 25.1305C29.74 25.5905 29.55 26.0205 29.28 26.4105C29.01 26.8005 28.67 27.1205 28.27 27.3805C27.87 27.6305 27.43 27.8005 26.97 27.8905C27.43 27.8105 27.91 27.8205 28.37 27.9205C28.83 28.0205 29.26 28.2105 29.65 28.4805C30.04 28.7505 30.36 29.0905 30.62 29.4905C30.87 29.8905 31.04 30.3305 31.12 30.7905C31.04 30.3305 31.05 29.8505 31.15 29.3905C31.25 28.9305 31.44 28.5005 31.71 28.1105C31.98 27.7305 32.32 27.4005 32.72 27.1405C33.12 26.8905 33.56 26.7205 34.02 26.6305H34.01Z",
    stroke: "#556266",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.14 109.07C104.47 109.07 102.8 108.43 101.53 107.16L84.14 89.7703C81.59 87.2203 81.59 83.1003 84.14 80.5503C86.69 78.0003 90.81 78.0003 93.36 80.5503L106.14 93.3303L136.3 63.1703C138.85 60.6203 142.97 60.6203 145.52 63.1703C148.07 65.7203 148.07 69.8403 145.52 72.3903L110.75 107.16C109.48 108.43 107.81 109.07 106.14 109.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174 180C177.31 180 180 177.31 180 174C180 170.69 177.31 168 174 168C170.69 168 168 170.69 168 174C168 177.31 170.69 180 174 180Z",
    stroke: "#556266",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.14 109.07C104.47 109.07 102.8 108.43 101.53 107.16L84.14 89.7703C81.59 87.2203 81.59 83.1003 84.14 80.5503C86.69 78.0003 90.81 78.0003 93.36 80.5503L106.14 93.3303L136.3 63.1703C138.85 60.6203 142.97 60.6203 145.52 63.1703C148.07 65.7203 148.07 69.8403 145.52 72.3903L110.75 107.16C109.48 108.43 107.81 109.07 106.14 109.07Z",
    stroke: "#556266",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_332_16223"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessImage);
export default __webpack_public_path__ + "static/media/success-image.f39bb74f091836c88401c2b581f5ba8c.svg";
export { ForwardRef as ReactComponent };